import api from "@services/api";
// import enums from "@services/enum";
import User from "@models/user";
import router from "@router";
import config from "@configs/msal.json";
import { PublicClientApplication } from "@azure/msal-browser";
import decode from "jwt-decode";

var msalInstance = new PublicClientApplication(config);

const USER = "@USER";

export const authService = {
  isAuthenticated,
  setToken,
  getUser,
  getRefreshToken,
  getToken,
  hasRole,
  login,
  logout,
  refreshToken,
  token,
  loginMSAL,
  refreshTokenMSAL
};

function isAuthenticated() {
  var user = JSON.parse(localStorage.getItem(USER));

  if (user && user.token !== null) {
    //JWT eh expiration

    var expires = new Date((user.expires - 621355968000000000) / 10000);

    if (user.iss && user.iss.includes("microsoft")) {
      expires = new Date(user.expires);
    }
    var now = new Date();
    now.setMinutes(now.getMinutes() + 10);
    if (expires > now) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}

function loginMSAL() {
  if (msalInstance.getAllAccounts() > 0) {
    return true;
  }
  return false;
}

function refreshTokenMSAL() {
  if (loginMSAL()) {
    const myAccounts = msalInstance.getAllAccounts();
    const accessTokenRequest = {
      scopes: ["profile"],
      account: myAccounts[0]
    };
    this.msalInstance
      .acquireTokenSilent(accessTokenRequest)
      .then(function(accessTokenResponse) {
        token(accessTokenResponse.idToken, accessTokenResponse.expiresOn);
      })
      .catch(function(error) {
        console.log(error);
      });
  } else {
    localStorage.clear();
    if (window.location.pathname != "/Login") {
      router.push("/Login");
    }
  }
  return Promise.resolve(true);
}

function setToken(user) {
  localStorage.setItem(USER, JSON.stringify(user));
}

function getUser() {
  return JSON.parse(localStorage.getItem(USER));
}

function getToken() {
  return getUser()?.token;
}

function getRefreshToken() {
  return getUser()?.refreshToken;
}

function hasRole(roles) {
  return getUser()?.perfil ? roles.includes(getUser().perfil) : false;
}

function token(token, expires) {
  var user = new User(token, expires, "");
  setToken(user);
  setPerfil(user);

  const jwt = decode(token);
  this.email = jwt.preferred_username;

  api
    .get(`Usuario/getPropUsuario`, { params: { email: this.email } })
    .then(response => {
      user = new User(
        token,
        expires,
        response.data["data"].perfil,
        response.data["data"].clienteId,
        response.data["data"].cliente
      );
      setToken(user);
    });

  //token, expires, perfil, clienteId, clienteNome
  // user = new User(token, expires, "", )
  ///TODO metodo para buscar e inserir todas as informações ou apenas buscar

  // setPerfil(user);
  // setSistema(user);
  // setProps(user);
  return user;
}

// function setSistema(user) {
//   localStorage.setItem("sistema", JSON.stringify(user.sistema));
// }

function setPerfil(user) {
  api
    .get(`Usuario/getPerfil`, { params: { email: user.email } })
    .then(response => {
      // localStorage.setItem("perfil", JSON.stringify(response.data["data"].descricao));
      user.perfil = response.data["data"].descricao;
      setToken(user);
    });
}

function login(email, password) {
  return api
    .post(`api/Login`, { email: email, senha: password })
    .then(response => {
      if (response.data["status"].toLowerCase() == "success") {
        var data = response.data["data"];
        var user = new User(
          data.token,
          data.expiration,
          data.refreshToken.token
        );

        setToken(user);
        return user;
      } else {
        throw response;
      }
    })
    .catch(error => {
      throw error;
    });
}

function logout() {
  var user = JSON.parse(localStorage.getItem(USER));

  if (user.iss && user.iss.includes("microsoft")) {
    const myAccounts = msalInstance.getAllAccounts();
    const logoutRequest = {
      account: myAccounts[0]
    };
    msalInstance.logoutRedirect(logoutRequest);
  } else {
    //TODO implementar logout jwt
    localStorage.removeItem("@USER");
  }
  localStorage.removeItem("@USER");

  var cliente = localStorage.getItem("cliente");
  localStorage.removeItem("cliente");

  if (cliente == "") {
    router.push("/Login");
  } else {
    router.push({ path: "/Login", query: { q: cliente } });
  }
}

// function logoutJWT() {
//   var token = getRefreshToken();
//   if (token) {
//     api
//       .post(`api/Token/Revoke`, { token: token })
//       .then(response => {
//         if (response.data["status"].toLowerCase() !== "success") {
//           throw response;
//         }
//       })
//       .catch(error => {
//         throw error;
//       });
//   }
//   localStorage.removeItem(USER);
//   router.push("/Login");
// }

async function refreshToken() {
  var token = getRefreshToken();
  if (token) {
    return await api
      .post(`api/Token/Refresh`, { token: token })
      .then(response => {
        if (response.data["status"].toLowerCase() == "success") {
          var data = response.data["data"];
          var user = new User(
            data.token,
            data.expiration,
            data.refreshToken.token
          );
          setToken(user);
          return user;
        } else {
          localStorage.clear();
          if (window.location.pathname != "/Login") {
            router.push("/Login");
          }
        }
      })
      .catch(() => {
        localStorage.clear();
        if (window.location.pathname.includes("Login")) {
          router.push("/Login");
        }
      });
  }
}

export default authService;
